import { render, staticRenderFns } from "./nav_controls.vue?vue&type=template&id=6c8110ae&"
import script from "./nav_controls.vue?vue&type=script&lang=js&"
export * from "./nav_controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports